import type {MetadataType} from '../constants';
import {MetadataTypeLabel} from '../locales';

export const getMetadataTypeLabel = (type: MetadataType) =>
	MetadataTypeLabel[type];

export default getMetadataTypeLabel;
